<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST" role="form">
      <div v-if="deleting">
          <p>Are you sure you want to delete <em>'{{ text }}'</em>?</p>
      </div>
      <div v-else>
        <div class="form-group row">
          <label for="inputName" class="col-sm-2 col-form-label">Name:</label>
          <div class="col-sm-10">
            <input type="text" name="text" id="inputName" class="form-control" required="required" v-model="text" placeholder="List item display name">
          </div>
        </div>

          <div class="form-group row">
            <label for="inputValue" class="col-sm-2 col-form-label">Value:</label>
            <div class="col-sm-10">
              <input type="text" name="value" id="inputValue" class="form-control" v-model="value" placeholder="Value to store in the database">
              <p>Leave blank to use display name as a value</p>
            </div>
          </div>

          <div v-if="lookupListClass === 'status_change_reason'" class="form-group row">
            <div class="col-sm-2"></div>
            <div class="col-sm-10">
              <div class="form-check">
                <input type="checkbox" name="is_tpa" id="isTpaCheckbox" class="form-check-input" v-model="isTpa">
                <label for="isTpaCheckbox" class="form-check-label">Enable TPA</label>
              </div>
              <input type="hidden" name="is_tpa" :value="isTpa ? 1 : 0">
            </div>
          </div>
        </div>

      <input type="hidden" name="_method" :value="method">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <template v-if="deleting">
        <button type="button" class="btn btn-default" @click.prevent="cancelDeletion">Cancel</button>
        <button type="submit" class="btn btn-danger" :form="formId">Delete</button>
      </template>
      <template v-else>
        <button type="button" class="btn btn-danger mr-auto" v-if="isExisting" @click.prevent="confirmDeletion">Delete</button>
        <button type="button" class="btn btn-default" @click="hideModal">Close</button>
        <button type="submit" class="btn btn-primary" :disabled="isEmpty" :form="formId">Save changes</button>
      </template>
    </template>

  </modal>
</template>

<script>
  import HasModal from "./mixins/HasModal";
  export default {
    mixins: [HasModal],

    props: {
      // Custom id for modal component.
      modalId: {
        type: String,
        default: 'lookup-item-modal'
      },
      id: {
        type: Number,
        default: 0
      },
      action: {
        type: String,
        required: true
      },
      initialText: {
        type: String,
        default: ''
      },
      initialValue: {
        type: String,
        default: ''
      },
      initialIsTpa: {
        type: Boolean,
        default: false
      },
      lookupListClass: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        text: this.initialText,
        value: this.initialValue,
        isTpa: this.initialIsTpa,
        deleting: false
      }
    },
    computed: {
      formId() {
        return this.modalId + '-form';
      },
      title() {
        if (this.deleting) return 'Delete list item';
        return this.isNew ? "Add a list item" : "Edit list item";
      },
      method() {
        if (this.deleting) return 'DELETE';
        return this.isNew ? "POST" : "PATCH";
      },
      hasData() {
        return !!(this.text && this.text.trim().length);
      },
      isEmpty() {
        return !this.hasData;
      },
      isExisting() {
        return this.id > 0;
      },
      isNew() {
        return !this.isExisting;
      }
    },
    methods: {
      confirmDeletion() {
        this.deleting = true;
      },
      cancelDeletion() {
        this.deleting = false;
      },
    }
}
</script>
